import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
} from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { Observable, throwError } from 'rxjs';

const NULL_PATH_SEGMENT = /\/(null|undefined)(\/|$|\?)/;

@Injectable()
export class NullUrlInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (NULL_PATH_SEGMENT.test(req.url)) {
      const message = 'Blocked request with null/undefined path segment';

      console.warn(`[NullUrlInterceptor] ${message}: ${req.method} ${req.url}`);

      Sentry.withScope((scope) => {
        scope.setLevel('warning');
        scope.setTag('interceptor', 'NullUrlInterceptor');
        scope.setContext('httpRequest', {
          method: req.method,
          url: req.urlWithParams,
        });
        Sentry.captureMessage(message, 'warning');
      });

      return throwError(
        () =>
          new HttpErrorResponse({
            status: 400,
            statusText: 'Blocked URL',
            url: req.urlWithParams,
            error: {
              code: 'NULL_URL_BLOCKED',
              message,
            },
          }),
      );
    }
    return next.handle(req);
  }
}

export const NULL_URL_INTERCEPTOR = {
  provide: HTTP_INTERCEPTORS,
  useClass: NullUrlInterceptor,
  multi: true,
};
